import axios from 'axios'
import { ref, computed } from 'vue'

let _detailsData = {
    id: null,
    duration: null,
    start_time: '12:00',
    format: 'AM',
    artistId: null
}
let _payoutData = {
    budget: null
}
const URLS = {
    xhr: {
        mutate: {
            editEvent: '/api/event/manage/set-details',
            editEventPayout: '/api/event/manage/set-payout'
        }
    }
}
export const useEditSetData = (mode, set, emit) => {
    const editData = computed({
        get() {
            switch (mode.value) {
                case 'details':
                    return {
                        ..._detailsData,
                        start_time: set.value.start.split(' ')[0],
                        format: set.value.start.split(' ')[1]
                    }
                case 'payout':
                    return _payoutData
                default:
                    return {}
            }
        },
        set(newData) {
            switch (mode.value) {
                case 'details':
                    _detailsData = newData
                    break
                case 'payout':
                    _payoutData = newData
                    break
                default:
                    return
            }
        }
    })
    const updateSetDetails = async () => {
        try {
            emit('loading', true)
            const data = _prepDetailsData()
            await axios.post(`${URLS.xhr.mutate.editEvent}/${editData.value.id}`, data)

            emit('set-updated')
        } catch (err) {
            console.error(err)
        } finally {
            emit('loading', false)
        }
    }
    const updateSetPayout = async () => {
        try {
            emit('loading', true)
            const data = {
                artist_id: editData.value.artistId,
                budget: editData.value.budget,
                venue_id: editData.value.venueId
            }
            await axios.post(`${URLS.xhr.mutate.editEventPayout}/${editData.value.id}`, data)

            emit('set-updated')
        } catch (err) {
            console.error(err)
        } finally {
            emit('loading', false)
        }
    }

    function _prepDetailsData() {
        const data = {
            artist_id: editData.value.artistId,
            counter_offer_duration: parseFloat((editData.value.duration / 60).toFixed(2)),
            start_avail: `${editData.value.start_time} ${editData.value.format}`
        }
        return data
    }

    const hasError = ref(true)
    const handleError = (val) => {
        hasError.value = val
    }
    return {
        hasError,
        editData,
        handleError,
        updateSetDetails,
        updateSetPayout
    }
}
